var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.btnFlag),expression:"btnFlag"}],staticClass:"backtop",attrs:{"id":"backtop"},on:{"click":_vm.scrolltop}},[_c('i',{staticClass:"el-icon-arrow-up"})])}
var staticRenderFns = []

export { render, staticRenderFns }